var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5204 19.5271C31.4003 19.5271 34.5457 16.3818 34.5457 12.5018C34.5457 8.62189 31.4003 5.47656 27.5204 5.47656C23.6404 5.47656 20.4951 8.62189 20.4951 12.5018C20.4951 16.3818 23.6404 19.5271 27.5204 19.5271Z",
    fill: "#84C70D",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5186 19.5283C31.3985 19.5283 34.5438 16.383 34.5438 12.503C34.5438 9.50165 32.6617 6.93988 30.0133 5.93359",
    stroke: "#84C70D",
    strokeWidth: 4.39286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1175 29.3978C40.554 31.6866 38.2335 36.1009 34.1047 36.1009H18.5997C14.4708 36.1009 12.1504 31.6866 15.5868 29.3978C18.6692 27.3449 22.3709 26.1484 26.3522 26.1484C30.3334 26.1484 34.0352 27.3449 37.1175 29.3978Z",
    fill: "#84C70D",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6983 18.133C19.9042 18.133 23.3137 14.7235 23.3137 10.5177C23.3137 6.31184 19.9042 2.90234 15.6983 2.90234C11.4925 2.90234 8.08301 6.31184 8.08301 10.5177C8.08301 14.7235 11.4925 18.133 15.6983 18.133Z",
    fill: "#84C70D",
    fillOpacity: 0.2,
    stroke: "#84C70D",
    strokeWidth: 4.39286,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3625 28.8348C31.0876 31.3158 28.5722 36.1009 24.0966 36.1009H7.28933C2.81371 36.1009 0.298377 31.3158 4.02342 28.8348C7.36469 26.6094 11.3774 25.3125 15.693 25.3125C20.0086 25.3125 24.0213 26.6094 27.3625 28.8348Z",
    fill: "#84C70D",
    fillOpacity: 0.2,
    stroke: "#84C70D",
    strokeWidth: 4.39286
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4521 36.0956H34.105C38.2338 36.0956 40.5543 31.6813 37.1179 29.3925C36.169 28.7606 35.1614 28.2097 34.105 27.75",
    stroke: "#84C70D",
    strokeWidth: 4.39286,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.8b187e793a03c1f2896871b881880f50.svg";
export { ForwardRef as ReactComponent };